import type { Permission, UserRole } from "../types.ts";

export const probationPermission = {
  "probation-review:access": ["HR", "SUPERADMIN"],
} satisfies Partial<Record<Permission, UserRole[]>>;
